import { render } from "./xtx-carousel.vue?vue&type=template&id=0461d668&scoped=true"
import script from "./xtx-carousel.vue?vue&type=script&lang=js"
export * from "./xtx-carousel.vue?vue&type=script&lang=js"

import "./xtx-carousel.vue?vue&type=style&index=0&id=0461d668&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0461d668"]])

export default __exports__